import { c as _c } from "react/compiler-runtime";
import type { JSX } from 'react';
import { ToolbarButton } from './components/toolbar-button';
interface Props {
  snowfallProvider: {
    isSnowfallEnabled: boolean;
    toggleSnowfall: () => void;
  };
}
export function SnowfallToggle(t0) {
  const $ = _c(8);
  const {
    snowfallProvider: t1
  } = t0;
  const {
    isSnowfallEnabled,
    toggleSnowfall
  } = t1;
  const t2 = isSnowfallEnabled ? "Stop snowing" : "Start snowing";
  let t3;
  if ($[0] !== toggleSnowfall) {
    t3 = e => {
      toggleSnowfall();
      e.currentTarget.blur();
    };
    $[0] = toggleSnowfall;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const t4 = isSnowfallEnabled ? "opacity-100" : "opacity-50";
  let t5;
  if ($[2] !== t4) {
    t5 = <SnowflakeIcon className={t4} />;
    $[2] = t4;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  let t6;
  if ($[4] !== t2 || $[5] !== t3 || $[6] !== t5) {
    t6 = <ToolbarButton tabIndex={0} title={t2} onClick={t3}>{t5}</ToolbarButton>;
    $[4] = t2;
    $[5] = t3;
    $[6] = t5;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  return t6;
}
function SnowflakeIcon(t0) {
  const $ = _c(3);
  const {
    className
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <path d={"M8 16a.5.5 0 01-.5-.5v-1.293l-.646.647a.5.5 0 01-.707-.708L7.5 12.793V8.866l-3.4 1.963-.496\n      1.85a.5.5 0 11-.966-.26l.237-.882-1.12.646a.5.5 0 01-.5-.866l1.12-.646-.884-.237a.5.5 0 11.26-.966l1.848.495L7\n      8 3.6 6.037l-1.85.495a.5.5 0 01-.258-.966l.883-.237-1.12-.646a.5.5 0 11.5-.866l1.12.646-.237-.883a.5.5 0\n      11.966-.258l.495 1.849L7.5 7.134V3.207L6.147 1.854a.5.5 0 11.707-.708l.646.647V.5a.5.5 0 111 0v1.293l.647-.647a.5.5\n      0 11.707.708L8.5 3.207v3.927l3.4-1.963.496-1.85a.5.5 0 11.966.26l-.236.882 1.12-.646a.5.5 0 01.5.866l-1.12.646.883.237a.5.5\n      0 11-.26.966l-1.848-.495L9 8l3.4 1.963 1.849-.495a.5.5 0 01.259.966l-.883.237 1.12.646a.5.5 0 01-.5.866l-1.12-.646.236.883a.5.5\n      0 11-.966.258l-.495-1.849-3.4-1.963v3.927l1.353 1.353a.5.5 0 01-.707.708l-.647-.647V15.5a.5.5 0 01-.5.5z"} />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== className) {
    t2 = <svg fill="currentColor" viewBox="0 0 16 16" height="18" width="18" className={className}>{t1}</svg>;
    $[1] = className;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}